import { PipeTransform } from '@angular/core';
import { FilterTypesEnum } from '../models/filters/filterTypes.enum';
import { ISelectOption } from '../models/selectOptions';

/**
 * Generates select options from an enum
 * @param enumInstance The enum that we want to create the options from
 * @param pipeTransform Transform pipe that will be used for the display name
 * @returns A collection of select options
 */
export function createSelectOptionsFromEnum(enumInstance: object, pipeTransform?: PipeTransform): ISelectOption[] {
  return Object.keys(enumInstance)
    .filter((v) => isNaN(Number(v)))
    .map(
      (key) =>
        ({
          id: key,
          value: key,
          displayName: pipeTransform ? pipeTransform.transform(key) : key,
        }) as ISelectOption
    );
}

/**
 * Generates select options from an enum
 * @param enumInstance The enum that we want to create the options from
 * @param filterType The filter type that will be used for the filter type and the category of the options
 * @param pipeTransform Transform pipe that will be used for the display name
 * @returns A collection of select options
 */
export function createSelectOptionsMultiSelectWithCategoriesFromEnum(
  enumInstance: object,
  filterType: FilterTypesEnum,
  pipeTransform?: PipeTransform
): ISelectOption[] {
  return Object.keys(enumInstance)
    .filter((v) => isNaN(Number(v)))
    .map(
      (key) =>
        ({
          id: key,
          value: key,
          displayName: pipeTransform ? pipeTransform.transform(key) : key,
          filterType: filterType,
          categoryName: filterType,
        }) as ISelectOption
    );
}

export function createSelectOptionsFromStringArray(
  arrayItems: string[],
  pipeTransform?: PipeTransform
): ISelectOption[] {
  return arrayItems
    .map(
      (key) =>
        ({
          id: key,
          value: key,
          displayName: pipeTransform ? pipeTransform.transform(key) : key,
        }) as ISelectOption
    )
    .sort((opt1, opt2) => opt1.displayName.localeCompare(opt2.displayName));
}
